import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AcessTypeLayer from "../../components/AccessType/AcessTypeLayer";


const AcessTypeListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Access Type" />

        {/* UsersListLayer */}
        <AcessTypeLayer />

      </MasterLayout>

    </>
  );
};

export default AcessTypeListPage; 
